import DownloadIcon from '@/common/assets/icons/download.svg?react';
import FilesIcon from '@/common/assets/icons/files.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import { Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import useModal from '@/common/hooks/useModal';
import DownloadFilePrintedVersionModal from '@/modules/FileDetail/components/documentation/modals/DownloadFilePrintedVersionModal.tsx';

const FilePrintedVersion = () => {
  const { open, closeModal, openModal } = useModal();

  return (
    <>
      <CardButton
        title="نسخه چاپی"
        hasArrow={false}
        renderTag={() => (
          <Flex gap="3" alignItems="center">
            <DownloadIcon stroke={token('colors.purple-2')} />
            <Typography textStyle="b2" color="purple-2">
              دانلود
            </Typography>
          </Flex>
        )}
        cardProps={{
          boxShadow: 'none',
          onClick: openModal,
        }}
        renderIcon={() => <FilesIcon />}
      />
      <DownloadFilePrintedVersionModal open={open} closeModal={closeModal} />
    </>
  );
};

export default FilePrintedVersion;
